import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { InputSlider } from "@learningblocks/shared-components";

export function RangeControl(props) {
  const [value, setValue] = useState(props.configData.default);

  useEffect(() => {
    props.updateVariable(
      props.configData.variable_key,
      Number(value),
      props.index
    );
  }, [value]);

  const updateControl = (value) => {
    setValue(value);
  };

  return (
    <div>
      <InputSlider
        sceneData={props.configData}
        updateControl={updateControl}
        labelledby={`range_${props.index}`}
        ariaInterval={props.ariaInterval}
        dev={props.dev}
      />
    </div>
  );
}

RangeControl.propTypes = {
  configData: PropTypes.shape({
    default: PropTypes.any.isRequired,
    variable_key: PropTypes.string.isRequired,
  }).isRequired,
  updateVariable: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
RangeControl.defaultProps = {};
